import { RadioFragments } from '@/apollo/fragments/radio';
import { Field } from '@/form/decorators/Field';
import { Form } from '@/form/decorators/Form';
import GraphQLForm from '@/form/GraphQLForm';
import { Radio } from '@/types/api';
import gql from 'graphql-tag';
import { RadioForm } from '.';

@Form({
  apollo: {
    mutation: gql`
      mutation UpdateRadio($input: UpdateRadioInput!) {
        updateRadio(input: $input) {
          radio {
            ...Radio
          }
        }
      }
      ${RadioFragments.Radio}
    `,
  },
})
export class UpdateRadioForm extends GraphQLForm<Radio> implements RadioForm {
  @Field({
    static: true,
  })
  public readonly id: string;

  @Field()
  public title: string;

  @Field()
  public description: string;

  @Field()
  public fileKey: string;

  @Field()
  public sortOrder: number;

  constructor(radio: Radio) {
    super(radio);
    this.id = radio.id;
    this.title = radio.title;
    this.description = radio.description || '';
    this.fileKey = radio.fileKey;
    this.sortOrder = radio.sortOrder;
  }
}
